import axios from '../../localAxios';
import { checkForSpreadsheetMimeType } from '../../utils';
import { importQuizBySpreadsheetURL } from '../url';

export interface ImportQuizBySpreadsheetResponse {
  callback: null;
  id: number;
  name: string;
  sharable: boolean;
  version: number;
  date: string;
  soc: string;
  parentId: number;
}

interface ImportQuizBySpreadsheetParam {
  parentId: number;
  file: File;
}

// Adapted from Constants.js
export enum ImportSpreadsheetErrors {
  INVALID_FILE_TYPE = 26,
  FILE_TOO_LARGE = 840,
  FEATURE_NOT_AVAILABLE = 857,
  QUIZ_NAME_MISSING = 245,
  QUIZ_NAME_TOO_LONG = 120,
  QUESTIONS_MISSING = 125,
  TOO_MANY_QUESTIONS = 839,
  QUESTION_TYPE_MISSING = 201,
  QUESTION_TEXT_MISSING = 121,
  QUIZ_QUESTION_TOO_LONG = 124,
  QUIZ_ANSWER_TOO_LONG = 122,
  NOT_ENOUGH_ANSWERS = 123,
  INVALID_QUESTION_TYPE = 27,
}

export function importQuizToPersonalBySpreadsheet(
  onUploadProgress: (progressEvent: ProgressEvent) => void
) {
  return async function ({ parentId, file }: ImportQuizBySpreadsheetParam) {
    const { type } = file;
    checkForSpreadsheetMimeType(type);

    const formData = new FormData();

    formData.append('file', file);
    formData.append('parentId', String(parentId));

    const url = importQuizBySpreadsheetURL();
    const response = await axios.post<ImportQuizBySpreadsheetResponse>(
      url.href,
      formData,
      {
        onUploadProgress: onUploadProgress,
      }
    );
    return response.data;
  };
}
